import { type Page, type PortalSettings } from '@gorilla/portal-shared/src/schemas';
import { List, ListItem, ListItemIcon, Box, Heading, Flex, Icon, Divider, Label, Text, type IconProps } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';

type PagePickerModalProps = {
  portalSettings: PortalSettings;
  isOpen: boolean;
  onClose: () => void;
  onSelect: (page: Page) => void;
  title: string;
  icon: IconProps['icon'];
  description?: string;
  selectedPageId?: string;
  excludePageId?: string;
};

export function PagePickerModal({
  portalSettings,
  isOpen,
  onClose,
  onSelect,
  title,
  icon,
  description,
  selectedPageId,
  excludePageId,
}: PagePickerModalProps) {
  const pages = portalSettings.pages.filter((page) => page.id !== excludePageId);

  return (
    <AppModal
      show={isOpen}
      onClose={() => {
        onClose();
      }}
      contentSpacing={false}
      alertDialog={true}
      width={397}
    >
      <AppModalContent>
        <div
          style={{
            marginBottom: '4px',
          }}
        >
          <Flex direction="row" align="center" gap={8} style={{ marginBottom: '20px' }}>
            <Icon icon={icon} size={22} />
            <Heading type="h3" weight="bold" align="start">
              {title}
            </Heading>
          </Flex>
          <Box marginBottom="small" border={true} borderColor="layoutBorderColor" rounded="small">
            <div
              style={{
                overflowY: 'auto',
                maxHeight: 'calc(100vh - 252px)',
              }}
            >
              <List>
                {pages.map((page, index) => {
                  const isSelected = selectedPageId === page.id;

                  return (
                    <div key={index}>
                      <ListItem
                        className="portalmanager__content__listitem"
                        size="small"
                        onClick={() => {
                          onSelect(page);
                        }}
                        selected={isSelected as any}
                      >
                        <div
                          style={{
                            width: '18px',
                            height: '18px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '8px',
                          }}
                        >
                          {page.icon ? <i className={`fa-regular fa-${page.icon}`}></i> : <i className={`fa-regular fa-file`}></i>}
                        </div>

                        <div
                          style={{
                            flex: 1,
                          }}
                        >
                          <div
                            style={{
                              maxWidth: isSelected ? '245px' : '327px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {page.name}
                          </div>
                        </div>
                        {isSelected ? <Label text="Selected" /> : null}
                      </ListItem>
                      {index < pages.length - 1 && <Divider withoutMargin />}
                    </div>
                  );
                })}
              </List>
            </div>
          </Box>

          {description ? (
            <Text type="text2" align="start" color="secondary" element="p" style={{ marginTop: '24px', marginBottom: '8px' }}>
              {description}
            </Text>
          ) : null}
        </div>
      </AppModalContent>
    </AppModal>
  );
}
